import axios from "axios";

import { LocationUser } from "..";

export interface Company {
  companyId: string;
  companyName: string;
  companyCode: number | string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  password?: string;
  avatarPhotoPath?: string;
  userName?: string;
  isDeleted?: boolean;
}

export interface CompanyInfo {
  companyId: string;
  companyName: string;
  companyAvatar: string;
  locationCount: number;
  locationUserCount: number;
  isDeleted: boolean;
  companyCode: number | string;
}

export async function getAllCompanies() {
  return axios.get<CompanyInfo[]>("/Companies/getallcompany").then((res) =>
    res.data.map((company) => ({
      ...company,
      avatarPhotoPath: company.companyAvatar,
      companyCode: company.companyCode.toString().padStart(4, "0"),
    })),
  );
}

export async function getCompanyByUserId(userID: string) {
  return axios
    .get<Company>(`/Companies/getcompanybyuserid`, {
      params: { userId: userID },
    })
    .then((res) => ({
      ...res.data,
      companyCode: res.data.companyCode.toString().padStart(4, "0"),
    }));
}

export async function getCompanyById(companyId: string) {
  return axios
    .get<Company>(`/Companies/getcompanybyid`, {
      params: { companyId: companyId },
    })
    .then((res) => ({
      ...res.data,
      companyCode: res.data.companyCode.toString().padStart(4, "0"),
    }));
}

export async function addCompany(payload: Partial<Company>) {
  return axios
    .post<Company>(`/Companies/addcompany`, {
      ...payload,
    })
    .then((res) => res.data);
}

export async function updateCompanyName(params: {
  companyId: string;
  companyName: string;
}) {
  return axios
    .put(`/Companies/updatecompanyname`, params)
    .then((res) => res.data);
}

export async function updateCompanyCode(params: {
  companyId: string;
  companyCode: string;
}) {
  return axios
    .put(`/Companies/updatecompanycode`, params)
    .then((res) => res.data);
}

export async function updateCompany(company: Company) {
  return axios.put(`/Companies/updatecompany`, company).then((res) => res.data);
}

export async function getCompanyUsersByUserId(userID: string) {
  return await axios
    .get<
      LocationUser[]
    >(`CompanyLocations/getcompanylocationsinfobyuserid`, { params: { userId: userID } })
    .then((res) => res.data);
}

export async function updateCompanyStatus(companyId: string, status: boolean) {
  return axios
    .put("Companies/updatecompanystatus", { companyId, status })
    .then((res) => res.data);
}
